import React, { useState } from 'react';
import { useBusinessContext } from '../contexts/BusinessContext';
import { generateThemeStudioUrlWithToken } from '../utils/themeStudio';
import { motivationalMessages } from '../data/staticData';
import './WebsiteStudioDialog.css';

export function WebsiteStudioDialog() {
  const {
    isWebsiteStudioDialogOpen,
    closeWebsiteStudioDialog,
    businessDetails,
    openBusinessSetupDialog,
    openOrderDetailsDialog,
    openPricingDialog,
    setCurrentMessage
  } = useBusinessContext();

  const [isOpeningThemeStudio, setIsOpeningThemeStudio] = useState(false);

  const handleBackToBusinessSetup = () => {
    closeWebsiteStudioDialog();
    openBusinessSetupDialog();
  };

  const handleOpenThemeStudio = async () => {
    if (!businessDetails?.selectedPricingPlan?.hasThemeStudio) {
      return;
    }

    setIsOpeningThemeStudio(true);
    try {
      const themeStudioUrl = await generateThemeStudioUrlWithToken({
        siteName: businessDetails.siteName,
      });

      // Open theme studio in new tab
      window.open(themeStudioUrl, '_blank');
      setCurrentMessage(motivationalMessages.themeStudioUnlocked);
    } catch (error) {
      console.error('Failed to open Theme Studio:', error);
      setCurrentMessage('Failed to open Theme Studio. Please try again.');
    } finally {
      setIsOpeningThemeStudio(false);
    }
  };

  const handleSkipThemeStudio = () => {
    setCurrentMessage('You can always customize your theme later!');
    closeWebsiteStudioDialog();
    openOrderDetailsDialog();
  };

  const handleUpgradeToThemeStudio = () => {
    setCurrentMessage('Choose a plan that includes Theme Studio to unlock this feature!');
    closeWebsiteStudioDialog();
    openPricingDialog();
  };

  if (!isWebsiteStudioDialogOpen || !businessDetails) return null;

  const hasThemeStudio = businessDetails.selectedPricingPlan?.hasThemeStudio || false;

  return (
    <div className="website-studio-overlay" onClick={closeWebsiteStudioDialog}>
      <div className="website-studio-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="website-studio-header">
          <button className="website-studio-back" onClick={handleBackToBusinessSetup}>
            ←
          </button>
          <button className="website-studio-close" onClick={closeWebsiteStudioDialog}>
            ×
          </button>
        </div>

        <div className="website-studio-content">
          <div className="website-studio-icon">
            <span className="website-studio-icon-emoji">🎨</span>
          </div>
          <h2 className="website-studio-title">Website Studio</h2>
          <p className="website-studio-description">
            Customize your platform's appearance with our advanced theme studio
          </p>

          {hasThemeStudio ? (
            <div className="website-studio-has-access">
              <div className="website-studio-success-card">
                <span className="website-studio-success-icon">✨</span>
                <span className="website-studio-success-text">
                  Theme Studio Included!
                </span>
              </div>
              <p className="website-studio-success-description">
                Your {businessDetails.selectedPricingPlan?.name || businessDetails.selectedPlan} includes full access to our Theme Studio
              </p>
              <button
                // we disabling this button to open theme studio in new tab intentionally.
                // onClick={handleOpenThemeStudio}
                disabled={isOpeningThemeStudio}
                className="website-studio-open-button"
              >
                {isOpeningThemeStudio ? 'Opening...' : '🎨 Just complete a few simple steps and the payment. After that, you’ll be able to access your Theme Studio under your Order Details.'}
              </button>
            </div>
          ) : (
            <div className="website-studio-no-access">
              <div className="website-studio-info-card">
                <span className="website-studio-info-icon">✨</span>
                <span className="website-studio-info-text">
                  Theme Studio is not available for your selected plan
                </span>
              </div>
              <button
                onClick={handleUpgradeToThemeStudio}
                className="website-studio-upgrade-button"
              >
                Upgrade to Theme Studio
              </button>
            </div>
          )}

          <button
            onClick={handleSkipThemeStudio}
            className="website-studio-skip-button"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

